import { render } from "./EquipaView.vue?vue&type=template&id=2cac6c0a&scoped=true"
import script from "./EquipaView.vue?vue&type=script&lang=js"
export * from "./EquipaView.vue?vue&type=script&lang=js"

import "./EquipaView.vue?vue&type=style&index=0&id=2cac6c0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cac6c0a"]])

export default __exports__